import { ColumnsType } from "antd/es/table";
import { Participant } from "@types";
import { Translation } from "react-i18next";
import { TableFilterDropdown } from "@components";
import { Search } from "lucide-react";

export const participantTable: ColumnsType<Participant> = [
    {
        title: <Translation>
        {
            t => t("table.nameLastname")
        }
        </Translation>,
        dataIndex: "firstName",
        key: "firstName",
        filterSearch: true,
        filterIcon: (filtered: boolean) => (
            <Search style={{ color: filtered ? "#F1B80E" : undefined }} />
            ),
        onFilter: (value: any, record) => `${(record.firstName ?? '').toLowerCase()} ${(record.lastName ?? '').toLowerCase()}`.includes((value ?? '').toLowerCase()),
        filterDropdown: ({
            setSelectedKeys,
            selectedKeys,
            confirm,
            clearFilters,
          }) => (
            <TableFilterDropdown setSelectedKeys={setSelectedKeys} selectedKeys={selectedKeys} confirm={confirm} clearFilters={clearFilters} prefixCls={""} close={function (): void {
                throw new Error("Function not implemented.");
            } } visible={false}/>
          ),
        render(_, record) {
            return `${record.firstName} ${record.lastName}`;
        }
    },
    {
        title: "OIB",
        dataIndex: "oib",
        key: "oib"
    },
    {
        title: <Translation>
        {
            t => t("table.email")
        }
        </Translation>,
        dataIndex: "email",
        key: "email"
    }
]